<template>
    <div :class="className">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: ['contentClass'],
        computed: {
            className() {
                if ( this.$store.state.layout.container ) {
                    return this.contentClass + ' bg-body';
                }
                return this.contentClass + ' bg-white';
            }
        }
    }
</script>